<template>
  <el-input v-model="title" ref="taskInput" class="task-title-edit-class" placeholder="添加任务，按回车键(enter)保存"
    @input="handleInput" @keyup.enter.native="handleEnterEvent" @blur="handleTaskTitleBlur"></el-input>
</template>

<script>
export default {
  name: 'TaskInput',
  props: {
    value
  },
  data () {
    return {
      title: '',
      save: false
    }
  },

  watch: {
    value (val) {
      this.title = val
    }
  },
  methods: {
    focus () {
      this.$refs.taskInput.focus()
    },
    blur () {
      this.$refs.taskInput.blur()
    },
    handleInput (e) {
      this.$emit('input', e)
    },
    handleEnterEvent () {
      this.save = true;
      this.$emit('enter', this.title)
      this.blur()
    },
    handleTaskTitleBlur () {
      this.$emit('blur', this.save)
      this.save = false
    }
  }

}
</script>

<style>

</style>